import { render, staticRenderFns } from "./roadshow.vue?vue&type=template&id=212ec1c2&scoped=true"
import script from "./roadshow.vue?vue&type=script&setup=true&lang=js"
export * from "./roadshow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./roadshow.vue?vue&type=style&index=0&id=212ec1c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ec1c2",
  null
  
)

export default component.exports